import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "26",
  height: "27",
  viewBox: "0 0 26 27"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M15.473 11.251L25.154 0H22.86l-8.404 9.77L7.742 0H0l10.15 14.773L0 26.57h2.294l8.875-10.316 7.089 10.316H26L15.473 11.25zm-3.141 3.652l-1.029-1.471L3.12 1.727h3.523l6.604 9.446 1.029 1.471 8.584 12.28h-3.523l-7.005-10.02v-.001z" }, null, -1)
  ]))]))
}
export default { render: render }